import { loadStripe } from "@stripe/stripe-js";

let stripePromise;

export default function getStripe(key) {
  if (!stripePromise) {
    stripePromise = loadStripe(key);
  }
  return stripePromise;
}